'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _chemist = require('chemist');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AdyenCheckout = (_dec = (0, _chemist.configurable)(), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(AdyenCheckout, _React$Component);

  function AdyenCheckout() {
    (0, _classCallCheck3.default)(this, AdyenCheckout);
    return (0, _possibleConstructorReturn3.default)(this, (AdyenCheckout.__proto__ || (0, _getPrototypeOf2.default)(AdyenCheckout)).apply(this, arguments));
  }

  (0, _createClass3.default)(AdyenCheckout, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactHelmet2.default, {
          script: [this.js],
          link: [this.css]
        })
      );
    }
  }, {
    key: 'js',
    get: function get() {
      var _props$config$adyenSd = this.props.config.adyenSdk.js,
          url = _props$config$adyenSd.url,
          integrity = _props$config$adyenSd.integrity;


      return (0, _extends3.default)({}, integrity ? { integrity: integrity } : {}, {
        src: url,
        type: 'text/javascript',
        crossorigin: 'anonymous'
      });
    }
  }, {
    key: 'css',
    get: function get() {
      var _props$config$adyenSd2 = this.props.config.adyenSdk.css,
          url = _props$config$adyenSd2.url,
          integrity = _props$config$adyenSd2.integrity;


      return (0, _extends3.default)({}, integrity ? { integrity: integrity } : {}, {
        href: url,
        rel: 'stylesheet',
        crossorigin: 'anonymous'
      });
    }
  }]);
  return AdyenCheckout;
}(_react2.default.Component)) || _class);
exports.default = AdyenCheckout;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/AdyenCheckout/index.js
// module id = 579
// module chunks = 0